import HeaderScreen from '@assets/FireboardScreens/HeaderScreen.png';
import ChecksDataScreen from '@assets/FireboardScreens/ChecksDataScreen.png';
import CheckDetailsScreen from '@assets/FireboardScreens/CheckDetailsScreen.png';
import ActionButtonsScreen from '@assets/FireboardScreens/ActionButtonsScreen.png';
import CheckStatusScreen from '@assets/FireboardScreens/CheckStatusScreen.png';
import NotifyGuestScreen from '@assets/FireboardScreens/NotifyGuestScreen.png';
import PrintScreen from '@assets/FireboardScreens/PrintScreen.png';
import ReceiptScreen from '@assets/FireboardScreens/ReceiptScreen.png';
import NotificationsScreen from '@assets/FireboardScreens/NotificationsScreen.png';
import ErrorOrdersScreen from '@assets/FireboardScreens/ErrorOrdersScreen.png';
import OutOfStockScreen from '@assets/FireboardScreens/OutOfStockScreen.png';
import ChannelScreen from '@assets/FireboardScreens/ChannelScreen.png';
import BulkTextToPayScreen from '@assets/FireboardScreens/BulkTextToPayScreen.png';
import AssignEmployeeScreen from '@assets/FireboardScreens/AssignEmployeeScreen.png';
import SensorsScreen from '@assets/FireboardScreens/SensorsScreen.png';
import AboutScreen from '@assets/FireboardScreens/AboutScreen.png';
import HamburgerMenuScreen from '@assets/FireboardScreens/HamburgerMenuScreen.png';
import CountersScreen from '@assets/FireboardScreens/CountersScreen.png';
import RepostPaymentScreen from '@assets/FireboardScreens/RepostPaymentScreen.png';
import LoaderComponentsScreen from '@assets/FireboardScreens/LoaderComponentsScreen.png';

export default {
  HeaderScreen: {
    screenLabel: 'Header',
    image: [HeaderScreen],
    customLabels: [
      {
        defaultText: 'Channel',
        key: 'label.HEADER_CHANNEL',
        type: 'label',
        value: 'HEADER_CHANNEL',
      },
      {
        defaultText: 'Status',
        key: 'label.HEADER_STATUS',
        type: 'label',
        value: 'HEADER_STATUS',
      },
      {
        defaultText: 'Search',
        key: 'label.HEADER_SEARCH',
        type: 'label',
        value: 'HEADER_SEARCH',
      },
      {
        defaultText: 'Sort by Name',
        key: 'label.HEADER_SORTNAME',
        type: 'label',
        value: 'HEADER_SORTNAME',
      },
      {
        defaultText: 'Sort by Time',
        key: 'label.HEADER_SORTTIME',
        type: 'label',
        value: 'HEADER_SORTTIME',
      },
      {
        defaultText: 'ASC',
        key: 'label.HEADER_ASC',
        type: 'label',
        value: 'HEADER_ASC',
      },
      {
        defaultText: 'DEC',
        key: 'label.HEADER_DEC',
        type: 'label',
        value: 'HEADER_DEC',
      },
      {
        defaultText: 'Closed',
        key: 'label.HEADER_CLOSED',
        type: 'label',
        value: 'HEADER_CLOSED',
      },
      {
        defaultText: 'All',
        key: 'label.HEADER_ALL',
        type: 'label',
        value: 'HEADER_ALL',
      },
      {
        defaultText: 'Unpaid',
        key: 'label.HEADER_UNPAID',
        type: 'label',
        value: 'HEADER_UNPAID',
      },
      {
        defaultText: 'Cubby Manager',
        key: 'label.HEADER_CUBBY_MANAGER',
        type: 'label',
        value: 'HEADER_CUBBY_MANAGER',
      },
      {
        defaultText: 'Future Orders',
        key: 'label.HEADER_FUTURE_ORDERS',
        type: 'label',
        value: 'HEADER_FUTURE_ORDERS',
      },
      {
        defaultText: 'Select Future Date',
        key: 'label.HEADER_FUTURE_DATE',
        type: 'label',
        value: 'HEADER_FUTURE_DATE',
      },
      {
        defaultText: 'Bulk Text To Pay',
        key: 'label.HEADER_BULK_TEXT_TO_PAY',
        type: 'label',
        value: 'HEADER_BULK_TEXT_TO_PAY',
      },
      {
        defaultText: 'Out Of Stock',
        key: 'label.HEADER_OUT_OF_STOCK',
        type: 'label',
        value: 'HEADER_OUT_OF_STOCK',
      },
      {
        defaultText: 'Assign Employee',
        key: 'label.HEADER_ASSIGN_EMPLOYEE',
        type: 'label',
        value: 'HEADER_ASSIGN_EMPLOYEE',
      },
      {
        defaultText: 'Table Sensors',
        key: 'label.HEADER_TABLE_SENSORS',
        type: 'label',
        value: 'HEADER_TABLE_SENSORS',
      },
      {
        defaultText: 'Named Sensors',
        key: 'label.HEADER_NAMED_SENSORS',
        type: 'label',
        value: 'HEADER_NAMED_SENSORS',
      },
      {
        defaultText: 'About',
        key: 'label.HEADER_ABOUT',
        type: 'label',
        value: 'HEADER_ABOUT',
      },
      {
        defaultText: 'Move Slot',
        key: 'label.HEADER_MOVESLOT',
        type: 'label',
        value: 'HEADER_MOVESLOT',
      },
      {
        defaultText: 'Items',
        key: 'label.HEADER_ITEMS',
        type: 'label',
        value: 'HEADER_ITEMS',
      },
      {
        defaultText: 'Modifiers',
        key: 'label.HEADER_MODIFIERS',
        type: 'label',
        value: 'HEADER_MODIFIERS',
      },
      {
        defaultText: 'Employee View',
        key: 'label.HEADER_EMPLOYEEVIEW',
        type: 'label',
        value: 'HEADER_EMPLOYEEVIEW',
      },
      {
        defaultText: 'Table View',
        key: 'label.HEADER_TABLEVIEW',
        type: 'label',
        value: 'HEADER_TABLEVIEW',
      },
      {
        defaultText: 'Table',
        key: 'label.HEADER_TABLE',
        type: 'label',
        value: 'HEADER_TABLE',
      },
      {
        defaultText: 'Named',
        key: 'label.HEADER_NAMED',
        type: 'label',
        value: 'HEADER_NAMED',
      },
      {
        defaultText: 'Sensor Group',
        key: 'label.HEADER_SENSORGROUP',
        type: 'label',
        value: 'HEADER_SENSORGROUP',
      },
      {
        defaultText: 'Add Sensor',
        key: 'label.HEADER_ADDSENSOR',
        type: 'label',
        value: 'HEADER_ADDSENSOR',
      },
      {
        defaultText: 'Assign Sensor Group',
        key: 'label.HEADER_ASSIGNSENSORGROUP',
        type: 'label',
        value: 'HEADER_ASSIGNSENSORGROUP',
      },
      {
        defaultText: 'Error Orders',
        key: 'label.HEADER_ERROR_ORDERS',
        type: 'label',
        value: 'HEADER_ERROR_ORDERS',
      },
      {
        defaultText: 'Notifications',
        key: 'label.HEADER_NOTIFICATIONS',
        type: 'label',
        value: 'HEADER_NOTIFICATIONS',
      },
      {
        defaultText: 'Location',
        key: 'label.HEADER_LOCATION',
        type: 'label',
        value: 'HEADER_LOCATION',
      },
      {
        defaultText: 'Order Type',
        key: 'label.HEADER_ORDER_TYPE',
        type: 'label',
        value: 'HEADER_ORDER_TYPE',
      },
      {
        defaultText: 'Revenue Center',
        key: 'label.HEADER_REVENUE_CENTER',
        type: 'label',
        value: 'HEADER_REVENUE_CENTER',
      },
      {
        defaultText: 'Employee',
        key: 'label.HEADER_EMPLOYEE',
        type: 'label',
        value: 'HEADER_EMPLOYEE',
      },
    ],
  },
  ChannelScreen: {
    screenLabel: 'Channel',
    image: [ChannelScreen],
    customLabels: [
      {
        defaultText: 'POS',
        key: 'label.CHANNEL_POS',
        type: 'label',
        value: 'CHANNEL_POS',
      },
      {
        defaultText: 'Kiosk',
        key: 'label.CHANNEL_KIOSK',
        type: 'label',
        value: 'CHANNEL_KIOSK',
      },
      {
        defaultText: 'Curbside',
        key: 'label.CHANNEL_CURBSIDE',
        type: 'label',
        value: 'CHANNEL_CURBSIDE',
      },
      {
        defaultText: 'Online',
        key: 'label.CHANNEL_ONLINE',
        type: 'label',
        value: 'CHANNEL_ONLINE',
      },
      {
        defaultText: 'Walk Up',
        key: 'label.CHANNEL_WALKUP',
        type: 'label',
        value: 'CHANNEL_WALKUP',
      },
      {
        defaultText: 'Call In',
        key: 'label.CHANNEL_CALL_IN',
        type: 'label',
        value: 'CHANNEL_CALL_IN',
      },
      {
        defaultText: 'Counter',
        key: 'label.CHANNEL_COUNTER',
        type: 'label',
        value: 'CHANNEL_COUNTER',
      },
      {
        defaultText: 'Call Center',
        key: 'label.CHANNEL_CALL_CENTER',
        type: 'label',
        value: 'CHANNEL_CALL_CENTER',
      },
      {
        defaultText: 'Speed Order',
        key: 'label.CHANNEL_SPEED_ORDER',
        type: 'label',
        value: 'CHANNEL_SPEED_ORDER',
      },
      {
        defaultText: 'Drive Thru',
        key: 'label.CHANNEL_DRIVE_THRU',
        type: 'label',
        value: 'CHANNEL_DRIVE_THRU',
      },
      {
        defaultText: 'Order Pay',
        key: 'label.CHANNEL_ORDER_PAY',
        type: 'label',
        value: 'CHANNEL_ORDER_PAY',
      },
    ]
  },
  CheckStatusScreen: {
    screenLabel: 'Check Status',
    image: [CheckStatusScreen],
    customLabels: [
      {
        defaultText: 'Pending',
        key: 'label.STATUS_PENDING',
        type: 'label',
        value: 'STATUS_PENDING',
      },
      {
        defaultText: 'In Progress',
        key: 'label.STATUS_PROGRESS',
        type: 'label',
        value: 'STATUS_PROGRESS',
      },
      {
        defaultText: 'Complete',
        key: 'label.STATUS_COMPLETE',
        type: 'label',
        value: 'STATUS_COMPLETE',
      },
      {
        defaultText: 'Picked Up',
        key: 'label.STATUS_PICKEDUP',
        type: 'label',
        value: 'STATUS_PICKEDUP',
      },
      {
        defaultText: 'Cancelled',
        key: 'label.STATUS_CANCELLED',
        type: 'label',
        value: 'STATUS_CANCELLED',
      },
      {
        defaultText: 'Error',
        key: 'label.STATUS_ERROR',
        type: 'label',
        value: 'STATUS_ERROR',
      },
      {
        defaultText: 'See Counter',
        key: 'label.STATUS_SEE_COUNTER',
        type: 'label',
        value: 'STATUS_SEE_COUNTER',
      },
      {
        defaultText: 'Open',
        key: 'label.STATUS_OPEN',
        type: 'label',
        value: 'STATUS_OPEN',
      },
    ]
  },
  NotificationsScreen: {
    screenLabel: 'Notifications Screen',
    image: [NotificationsScreen],
    customLabels: [
      {
        defaultText: 'Type',
        key: 'label.NOTIFICATION_TYPE',
        type: 'label',
        value: 'NOTIFICATION_TYPE',
      },
      {
        defaultText: 'Time',
        key: 'label.NOTIFICATION_TIME',
        type: 'label',
        value: 'NOTIFICATION_TIME',
      },
      {
        defaultText: 'Message',
        key: 'label.NOTIFICATION_MESSAGE',
        type: 'label',
        value: 'NOTIFICATION_MESSAGE',
      },
      {
        defaultText: 'Actions',
        key: 'label.NOTIFICATION_ACTIONS',
        type: 'label',
        value: 'NOTIFICATION_ACTIONS',
      },
      {
        defaultText: 'Dismiss',
        key: 'label.NOTIFICATION_DISMISS',
        type: 'label',
        value: 'NOTIFICATION_DISMISS',
      },
      {
        defaultText: 'Go & Dismiss',
        key: 'label.NOTIFICATION_GO_DISMISS',
        type: 'label',
        value: 'NOTIFICATION_GO_DISMISS',
      },
      {
        defaultText: 'No Notifications Available',
        key: 'label.NOTIFICATION_NO_NOTIFICATIONS_AVAILABLE',
        type: 'label',
        value: 'NOTIFICATION_NO_NOTIFICATIONS_AVAILABLE',
      },
      {
        defaultText: 'Store',
        key: 'label.NOTIFICATION_STORE',
        type: 'label',
        value: 'NOTIFICATION_STORE',
      },
    ]
  },
  ErrorOrdersScreen: {
    screenLabel: 'Error Orders Screen',
    image: [ErrorOrdersScreen],
    customLabels: [
      {
        defaultText: 'Channel',
        key: 'label.ERROR_CHANNEL',
        type: 'label',
        value: 'ERROR_CHANNEL',
      },
      {
        defaultText: 'Check Number',
        key: 'label.ERROR_CHECK_NUMBER',
        type: 'label',
        value: 'ERROR_CHECK_NUMBER',
      },
      {
        defaultText: 'Name',
        key: 'label.ERROR_NAME',
        type: 'label',
        value: 'ERROR_NAME',
      },
      {
        defaultText: 'Phone Number',
        key: 'label.ERROR_PHONE_NUMBER',
        type: 'label',
        value: 'ERROR_PHONE_NUMBER',
      },
      {
        defaultText: 'Pickup Date and Time',
        key: 'label.ERROR_PICKUP_DETAILS',
        type: 'label',
        value: 'ERROR_PICKUP_DETAILS',
      },
      {
        defaultText: 'Error Message',
        key: 'label.ERROR_ERROR_MESSAGE',
        type: 'label',
        value: 'ERROR_ERROR_MESSAGE',
      },
      {
        defaultText: 'No Error Orders Available',
        key: 'label.ERROR_NO_ERROR_ORDERS',
        type: 'label',
        value: 'ERROR_NO_ERROR_ORDERS',
      },
    ]
  },
  ChecksDataScreen: {
    screenLabel: 'Checks Data',
    image: [ChecksDataScreen],
    customLabels: [
      {
        defaultText: 'Channel',
        key: 'label.CHECK_CHANNEL',
        type: 'label',
        value: 'CHECK_CHANNEL',
      },
      {
        defaultText: 'Check',
        key: 'label.CHECK_CHECK',
        type: 'label',
        value: 'CHECK_CHECK',
      },
      {
        defaultText: 'Table/ Tab',
        key: 'label.CHECK_TABLETAB',
        type: 'label',
        value: 'CHECK_TABLETAB',
      },
      {
        defaultText: 'Name',
        key: 'label.CHECK_NAME',
        type: 'label',
        value: 'CHECK_NAME',
      },
      {
        defaultText: 'Phone',
        key: 'label.CHECK_PHONE',
        type: 'label',
        value: 'CHECK_PHONE',
      },
      {
        defaultText: 'Elapsed',
        key: 'label.CHECK_ELAPSED',
        type: 'label',
        value: 'CHECK_ELAPSED',
      },
      {
        defaultText: 'Due',
        key: 'label.CHECK_DUE',
        type: 'label',
        value: 'CHECK_DUE',
      },
      {
        defaultText: 'Status',
        key: 'label.CHECK_STATUS',
        type: 'label',
        value: 'CHECK_STATUS',
      },
      {
        defaultText: 'Paid',
        key: 'label.CHECK_PAID',
        type: 'label',
        value: 'CHECK_PAID',
      },
      {
        defaultText: 'UnPaid',
        key: 'label.CHECK_UNPAID',
        type: 'label',
        value: 'CHECK_UNPAID',
      },
      {
        defaultText: 'Store',
        key: 'label.CHECK_STORE',
        type: 'label',
        value: 'CHECK_STORE',
      },
      {
        defaultText: 'Employee',
        key: 'label.CHECK_EMPLOYEE',
        type: 'label',
        value: 'CHECK_EMPLOYEE',
      },
      {
        defaultText: 'Open',
        key: 'label.CHECK_OPEN',
        type: 'label',
        value: 'CHECK_OPEN',
      },
      {
        defaultText: 'Close',
        key: 'label.CHECK_CLOSE',
        type: 'label',
        value: 'CHECK_CLOSE',
      },
      {
        defaultText: 'Closed',
        key: 'label.CHECK_CLOSED',
        type: 'label',
        value: 'CHECK_CLOSED',
      },
      {
        defaultText: 'Guest',
        key: 'label.CHECK_GUEST',
        type: 'label',
        value: 'CHECK_GUEST',
      },
      {
        defaultText: 'Remaining',
        key: 'label.CHECK_REMAINING',
        type: 'label',
        value: 'CHECK_REMAINING',
      },
      {
        defaultText: 'Order',
        key: 'label.CHECK_ORDER',
        type: 'label',
        value: 'CHECK_ORDER',
      },
      {
        defaultText: 'Checked In',
        key: 'label.CHECK_CHECKEDIN',
        type: 'label',
        value: 'CHECK_CHECKEDIN',
      },
      {
        defaultText: 'Check In Note',
        key: 'label.CHECK_CHECKINNOTE',
        type: 'label',
        value: 'CHECK_CHECKINNOTE',
      },
      {
        defaultText: 'Total',
        key: 'label.CHECK_TOTAL',
        type: 'label',
        value: 'CHECK_TOTAL',
      },
      {
        defaultText: 'Clear',
        key: 'label.CHECK_CLEAR',
        type: 'label',
        value: 'CHECK_CLEAR',
      },
      {
        defaultText: 'Move',
        key: 'label.CHECK_MOVE',
        type: 'label',
        value: 'CHECK_MOVE',
      },
      {
        defaultText: 'More Details',
        key: 'label.CHECK_MORE_DETAILS',
        type: 'label',
        value: 'CHECK_MORE_DETAILS',
      },
      {
        defaultText: 'Notify',
        key: 'label.CHECK_NOTIFY',
        type: 'label',
        value: 'CHECK_NOTIFY',
      },
      {
        defaultText: 'Progress',
        key: 'label.CHECK_PROGRESS',
        type: 'label',
        value: 'CHECK_PROGRESS',
      },
      {
        defaultText: 'Complete',
        key: 'label.CHECK_COMPLETE',
        type: 'label',
        value: 'CHECK_COMPLETE',
      },
      {
        defaultText: 'Picked Up',
        key: 'label.CHECK_PICKEDUP',
        type: 'label',
        value: 'CHECK_PICKEDUP',
      },
      {
        defaultText: 'Print',
        key: 'label.CHECK_PRINT',
        type: 'label',
        value: 'CHECK_PRINT',
      },
      {
        defaultText: 'Receipt',
        key: 'label.CHECK_RECEIPT',
        type: 'label',
        value: 'CHECK_RECEIPT',
      },
      {
        defaultText: 'Pick Up',
        key: 'label.CHECK_PICKUP',
        type: 'label',
        value: 'CHECK_PICKUP',
      },
      {
        defaultText: 'Tab',
        key: 'label.CHECK_TAB',
        type: 'label',
        value: 'CHECK_TAB',
      },
      {
        defaultText: 'No Checks Available',
        key: 'label.CHECK_NO_CHECKS_AVAILABLE',
        type: 'label',
        value: 'CHECK_NO_CHECKS_AVAILABLE',
      },
      {
        defaultText: 'Confirmation',
        key: 'label.CHECK_CLEAR_SLOT_CONFIRMATION',
        type: 'label',
        value: 'CHECK_CLEAR_SLOT_CONFIRMATION',
      },
      {
        defaultText: 'This will clear the order from Slot {{SlotNo}}. Do you want to continue? (eg: This will clear the order from Slot 1. Do you want to continue?)',
        key: 'label.CHECK_CLEAR_SLOT_MESSAGE',
        type: 'label',
        value: 'CHECK_CLEAR_SLOT_MESSAGE',
      },
      {
        defaultText: 'Yes',
        key: 'label.CHECK_YES',
        type: 'label',
        value: 'CHECK_YES',
      },
      {
        defaultText: 'No',
        key: 'label.CHECK_NO',
        type: 'label',
        value: 'CHECK_NO',
      },
    ]
  },
  CheckDetailsScreen: {
    screenLabel: 'Check Details',
    image: [CheckDetailsScreen],
    customLabels: [
      {
        defaultText: 'Items',
        key: 'label.DETAILS_ITEMS',
        type: 'label',
        value: 'DETAILS_ITEMS',
      },
      {
        defaultText: 'Subtotal',
        key: 'label.DETAILS_SUBTOTAL',
        type: 'label',
        value: 'DETAILS_SUBTOTAL',
      },
      {
        defaultText: 'Discounts',
        key: 'label.DETAILS_DISCOUNTS',
        type: 'label',
        value: 'DETAILS_DISCOUNTS',
      },
      {
        defaultText: 'Charges',
        key: 'label.DETAILS_CHARGES',
        type: 'label',
        value: 'DETAILS_CHARGES',
      },
      {
        defaultText: 'Tax',
        key: 'label.DETAILS_TAX',
        type: 'label',
        value: 'DETAILS_TAX',
      },
      {
        defaultText: 'Tip',
        key: 'label.DETAILS_TIP',
        type: 'label',
        value: 'DETAILS_TIP',
      },
      {
        defaultText: 'Paid',
        key: 'label.DETAILS_PAID',
        type: 'label',
        value: 'DETAILS_PAID',
      },
      {
        defaultText: 'Due',
        key: 'label.DETAILS_DUE',
        type: 'label',
        value: 'DETAILS_DUE',
      },
      {
        defaultText: 'Elapsed',
        key: 'label.DETAILS_ELAPSED',
        type: 'label',
        value: 'DETAILS_ELAPSED',
      },
      {
        defaultText: 'Remaining',
        key: 'label.DETAILS_REMAINING',
        type: 'label',
        value: 'DETAILS_REMAINING',
      },
      {
        defaultText: 'Due Time',
        key: 'label.DETAILS_DUETIME',
        type: 'label',
        value: 'DETAILS_DUETIME',
      },
      {
        defaultText: 'Unpaid',
        key: 'label.DETAILS_UNPAID',
        type: 'label',
        value: 'DETAILS_UNPAID',
      },
    ]
  },
  ActionButtonsScreen: {
    screenLabel: 'Action Buttons',
    image: [ActionButtonsScreen],
    customLabels: [
      {
        defaultText: 'Move To In-Progress',
        key: 'label.ACTION_PROGRESS',
        type: 'label',
        value: 'ACTION_PROGRESS',
      },
      {
        defaultText: 'Mark As Done',
        key: 'label.ACTION_DONE',
        type: 'label',
        value: 'ACTION_DONE',
      },
      {
        defaultText: 'Move To Picked Up',
        key: 'label.ACTION_PICKED',
        type: 'label',
        value: 'ACTION_PICKED',
      },
      {
        defaultText: 'Back To Pending',
        key: 'label.ACTION_BACK_TO_PENDING',
        type: 'label',
        value: 'ACTION_BACK_TO_PENDING',
      },
      {
        defaultText: 'Back To In-Progress',
        key: 'label.ACTION_BACK_TO_INPROGRESS',
        type: 'label',
        value: 'ACTION_BACK_TO_INPROGRESS',
      },
      {
        defaultText: 'Mark as Not Picked Up',
        key: 'label.ACTION_MARK_NOT_PICKEDUP',
        type: 'label',
        value: 'ACTION_MARK_NOT_PICKEDUP',
      },
      {
        defaultText: 'Cancel Order',
        key: 'label.ACTION_CANCEL_ORDER',
        type: 'label',
        value: 'ACTION_CANCEL_ORDER',
      },
      {
        defaultText: 'Notify Guest',
        key: 'label.ACTION_NOTIFY_GUEST',
        type: 'label',
        value: 'ACTION_NOTIFY_GUEST',
      },
      {
        defaultText: 'Print',
        key: 'label.ACTION_PRINT',
        type: 'label',
        value: 'ACTION_PRINT',
      },
      {
        defaultText: 'Receipt',
        key: 'label.ACTION_RECEIPT',
        type: 'label',
        value: 'ACTION_RECEIPT',
      },
      {
        defaultText: 'Sync Check',
        key: 'label.ACTION_SYNC_CHECK',
        type: 'label',
        value: 'ACTION_SYNC_CHECK',
      },
      {
        defaultText: 'Order Cancellation',
        key: 'label.ACTION_ORDER_CANCELLATION',
        type: 'label',
        value: 'ACTION_ORDER_CANCELLATION',
      },
      {
        defaultText: 'This action will cancel the order permanently. Are you sure you want to continue?',
        key: 'label.ACTION_CANCELLATION_MESSAGE',
        type: 'label',
        value: 'ACTION_CANCELLATION_MESSAGE',
      },
      {
        defaultText: 'Yes',
        key: 'label.ACTION_YES',
        type: 'label',
        value: 'ACTION_YES',
      },
      {
        defaultText: 'No',
        key: 'label.ACTION_NO',
        type: 'label',
        value: 'ACTION_NO',
      },
      {
        defaultText: 'Pre Auth',
        key: 'label.ACTION_PREAUTH',
        type: 'label',
        value: 'ACTION_PREAUTH',
      },
      {
        defaultText: 'Repost Payment',
        key: 'label.ACTION_REPOST',
        type: 'label',
        value: 'ACTION_REPOST',
      },
    ]
  },
  NotifyGuestScreen: {
    screenLabel: 'Notify Guest Screen',
    image: [NotifyGuestScreen],
    customLabels: [
      {
        defaultText: 'Custom and Standard Messages',
        key: 'label.NOTIFY_CUSTOM_STANDARD_MESSAGES',
        type: 'label',
        value: 'NOTIFY_CUSTOM_STANDARD_MESSAGES',
      },
      {
        defaultText: 'CANCEL',
        key: 'label.NOTIFY_CANCEL',
        type: 'label',
        value: 'NOTIFY_CANCEL',
      },
      {
        defaultText: 'SUBMIT',
        key: 'label.NOTIFY_SUBMIT',
        type: 'label',
        value: 'NOTIFY_SUBMIT',
      },
      {
        defaultText: 'Phone number is required - Please check the input and try again[Phone number is not available for this order]',
        key: 'label.NOTIFY_PHONE_ERROR',
        type: 'label',
        value: 'NOTIFY_PHONE_ERROR',
      },
      {
        defaultText: 'OK',
        key: 'label.NOTIFY_OK',
        type: 'label',
        value: 'NOTIFY_OK',
      },
    ]
  },
  PrintScreen: {
    screenLabel: 'Print Screen',
    image: [PrintScreen],
    customLabels: [
      {
        defaultText: 'Print',
        key: 'label.PRINT',
        type: 'label',
        value: 'PRINT',
      },
      {
        defaultText: 'Individual Item Labels',
        key: 'label.PRINT_INDIVIDUAL_ITEM_LABELS',
        type: 'label',
        value: 'PRINT_INDIVIDUAL_ITEM_LABELS',
      },
      {
        defaultText: 'Order + Item Labels',
        key: 'label.PRINT_ORDER_ITEM_LABELS',
        type: 'label',
        value: 'PRINT_ORDER_ITEM_LABELS',
      },
      {
        defaultText: 'Full Order Label',
        key: 'label.PRINT_FULL_ORDER_LABEL',
        type: 'label',
        value: 'PRINT_FULL_ORDER_LABEL',
      },
      {
        defaultText: 'Kitchen Ticket',
        key: 'label.PRINT_KITCHEN_TICKET',
        type: 'label',
        value: 'PRINT_KITCHEN_TICKET',
      },
      {
        defaultText: 'Guest Receipt',
        key: 'label.PRINT_GUEST_RECEIPT',
        type: 'label',
        value: 'PRINT_GUEST_RECEIPT',
      },
      {
        defaultText: 'Cancel',
        key: 'label.PRINT_CANCEL',
        type: 'label',
        value: 'PRINT_CANCEL',
      },
      {
        defaultText: 'Printer not setup for this table - Please setup a printer and try again',
        key: 'label.PRINT_ERROR',
        type: 'label',
        value: 'PRINT_ERROR',
      },
      {
        defaultText: 'OK',
        key: 'label.PRINT_OK',
        type: 'label',
        value: 'PRINT_OK',
      },
    ]
  },
  ReceiptScreen: {
    screenLabel: 'Receipt Screen',
    image: [ReceiptScreen],
    customLabels: [
      {
        defaultText: 'Re-send Receipt',
        key: 'label.RECEIPT',
        type: 'label',
        value: 'RECEIPT',
      },
      {
        defaultText: 'Type',
        key: 'label.RECEIPT_TYPE',
        type: 'label',
        value: 'RECEIPT_TYPE',
      },
      {
        defaultText: 'Card',
        key: 'label.RECEIPT_CARD',
        type: 'label',
        value: 'RECEIPT_CARD',
      },
      {
        defaultText: 'Name',
        key: 'label.RECEIPT_NAME',
        type: 'label',
        value: 'RECEIPT_NAME',
      },
      {
        defaultText: 'Total',
        key: 'label.RECEIPT_TOTAL',
        type: 'label',
        value: 'RECEIPT_TOTAL',
      },
      {
        defaultText: 'Tip',
        key: 'label.RECEIPT_TIP',
        type: 'label',
        value: 'RECEIPT_TIP',
      },
      {
        defaultText: 'Status',
        key: 'label.RECEIPT_STATUS',
        type: 'label',
        value: 'RECEIPT_STATUS',
      },
      {
        defaultText: 'Cancel',
        key: 'label.RECEIPT_CANCEL',
        type: 'label',
        value: 'RECEIPT_CANCEL',
      },
      {
        defaultText: 'Print',
        key: 'label.RECEIPT_PRINT',
        type: 'label',
        value: 'RECEIPT_PRINT',
      },
      {
        defaultText: 'Email',
        key: 'label.RECEIPT_EMAIL',
        type: 'label',
        value: 'RECEIPT_EMAIL',
      },
      {
        defaultText: 'Text',
        key: 'label.RECEIPT_TEXT',
        type: 'label',
        value: 'RECEIPT_TEXT',
      },
      {
        defaultText: 'Email Address',
        key: 'label.RECEIPT_EMAIL_ADDRESS',
        type: 'label',
        value: 'RECEIPT_EMAIL_ADDRESS',
      },
      {
        defaultText: 'Enter your email',
        key: 'label.RECEIPT_ENTER_EMAIL',
        type: 'label',
        value: 'RECEIPT_ENTER_EMAIL',
      },
      {
        defaultText: 'Done',
        key: 'label.RECEIPT_DONE',
        type: 'label',
        value: 'RECEIPT_DONE',
      },
      {
        defaultText: 'Phone Number',
        key: 'label.RECEIPT_PHONE_NUMBER',
        type: 'label',
        value: 'RECEIPT_PHONE_NUMBER',
      },
      {
        defaultText: 'Enter your phone number',
        key: 'label.RECEIPT_ENTER_PHONE',
        type: 'label',
        value: 'RECEIPT_ENTER_PHONE',
      },
      {
        defaultText: 'Refund',
        key: 'label.RECEIPT_REFUND',
        type: 'label',
        value: 'RECEIPT_REFUND',
      },
      {
        defaultText: 'Payment',
        key: 'label.RECEIPT_PAYMENT',
        type: 'label',
        value: 'RECEIPT_PAYMENT',
      },
      {
        defaultText: 'Enter valid phone number',
        key: 'label.RECEIPT_ERROR_PHONE',
        type: 'label',
        value: 'RECEIPT_ERROR_PHONE',
      },
      {
        defaultText: 'Enter valid email',
        key: 'label.RECEIPT_ERROR_EMAIL',
        type: 'label',
        value: 'RECEIPT_ERROR_EMAIL',
      },
      {
        defaultText: 'Generating email receipt',
        key: 'label.RECEIPT_EMAIL_SPINNER_MSG',
        type: 'label',
        value: 'RECEIPT_EMAIL_SPINNER_MSG',
      },
      {
        defaultText: 'Generating sms receipt',
        key: 'label.RECEIPT_SMS_SPINNER_MSG',
        type: 'label',
        value: 'RECEIPT_SMS_SPINNER_MSG',
      },
      {
        defaultText: 'Phone number requires 10 digits',
        key: 'label.RECEIPT_PHONE_DIGITS_ERROR',
        type: 'label',
        value: 'RECEIPT_PHONE_DIGITS_ERROR',
      },
    ]
  },
  RepostPaymentScreen: {
    screenLabel: 'Repost Payment Screen',
    image: [RepostPaymentScreen],
    customLabels: [
      {
        defaultText: 'Repost Payment',
        key: 'label.REPOST_PAYMENT_REPOST_PAYMENT',
        type: 'label',
        value: 'REPOST_PAYMENT_REPOST_PAYMENT',
      },
      {
        defaultText: 'Card Type',
        key: 'label.REPOST_CARD_TYPE',
        type: 'label',
        value: 'REPOST_CARD_TYPE',
      },
      {
        defaultText: 'Card #',
        key: 'label.REPOST_CARD',
        type: 'label',
        value: 'REPOST_CARD',
      },
      {
        defaultText: 'Name',
        key: 'label.REPOST_NAME',
        type: 'label',
        value: 'REPOST_NAME',
      },
      {
        defaultText: 'Total',
        key: 'label.REPOST_TOTAL',
        type: 'label',
        value: 'REPOST_TOTAL',
      },
      {
        defaultText: 'Tip',
        key: 'label.REPOST_TIP',
        type: 'label',
        value: 'REPOST_TIP',
      },
      {
        defaultText: 'Payment',
        key: 'label.REPOST_PAYMENT_PAYMENT',
        type: 'label',
        value: 'REPOST_PAYMENT_PAYMENT',
      },
      {
        defaultText: 'Success',
        key: 'label.REPOST_SUCCESS',
        type: 'label',
        value: 'REPOST_SUCCESS',
      },
      {
        defaultText: 'Cancel',
        key: 'label.REPOST_CANCEL',
        type: 'label',
        value: 'REPOST_CANCEL',
      },
      {
        defaultText: 'Submit',
        key: 'label.REPOST_SUBMIT',
        type: 'label',
        value: 'REPOST_SUBMIT',
      },
      {
        defaultText: 'Yes',
        key: 'label.REPOST_YES',
        type: 'label',
        value: 'REPOST_YES',
      },
      {
        defaultText: 'No',
        key: 'label.REPOST_NO',
        type: 'label',
        value: 'REPOST_NO',
      },
      {
        defaultText: 'Repost Payment Confirmation',
        key: 'label.REPOST_CONFIRMATION',
        type: 'label',
        value: 'REPOST_CONFIRMATION',
      },
      {
        defaultText: 'This will repost the payment to the pos. Do you want to continue?',
        key: 'label.REPOST_MESSAGE',
        type: 'label',
        value: 'REPOST_MESSAGE',
      },
      {
        defaultText: 'No Data Available',
        key: 'label.REPOST_NO_DATA_AVAILABLE',
        type: 'label',
        value: 'REPOST_NO_DATA_AVAILABLE',
      },
    ]
  },
  HamburgerMenuScreen: {
    screenLabel: 'Hamburger Menu',
    image: [HamburgerMenuScreen],
    customLabels: [
      {
        defaultText: 'Views',
        key: 'label.HAMBURGER_VIEWS',
        type: 'label',
        value: 'HAMBURGER_VIEWS',
      },
      {
        defaultText: 'List View',
        key: 'label.HAMBURGER_LIST_VIEW',
        type: 'label',
        value: 'HAMBURGER_LIST_VIEW',
      },
      {
        defaultText: 'Tile View',
        key: 'label.HAMBURGER_TILE_VIEW',
        type: 'label',
        value: 'HAMBURGER_TILE_VIEW',
      },
      {
        defaultText: 'Cubby Manager',
        key: 'label.HAMBURGER_CUBBY_MANAGER',
        type: 'label',
        value: 'HAMBURGER_CUBBY_MANAGER',
      },
      {
        defaultText: 'Order Status Manager',
        key: 'label.HAMBURGER_ORDER_STATUS_MANAGER',
        type: 'label',
        value: 'HAMBURGER_ORDER_STATUS_MANAGER',
      },
      {
        defaultText: 'Modes',
        key: 'label.HAMBURGER_MODES',
        type: 'label',
        value: 'HAMBURGER_MODES',
      },
      {
        defaultText: 'General Mode',
        key: 'label.HAMBURGER_GENERAL_MODE',
        type: 'label',
        value: 'HAMBURGER_GENERAL_MODE',
      },
      {
        defaultText: 'On Premise',
        key: 'label.HAMBURGER_ONPREMISE_MODE',
        type: 'label',
        value: 'HAMBURGER_ONPREMISE_MODE',
      },
      {
        defaultText: 'Off Premise',
        key: 'label.HAMBURGER_OFFPREMISE_MODE',
        type: 'label',
        value: 'HAMBURGER_OFFPREMISE_MODE',
      },
      {
        defaultText: 'Table Delivery',
        key: 'label.HAMBURGER_TABLE_DELIVERY',
        type: 'label',
        value: 'HAMBURGER_TABLE_DELIVERY',
      },
      {
        defaultText: 'Pre Auth',
        key: 'label.HAMBURGER_PREAUTH',
        type: 'label',
        value: 'HAMBURGER_PREAUTH',
      },
      {
        defaultText: 'Future Orders',
        key: 'label.HAMBURGER_FUTURE_ORDERS',
        type: 'label',
        value: 'HAMBURGER_FUTURE_ORDERS',
      },
      {
        defaultText: 'Bulk Text To Pay',
        key: 'label.HAMBURGER_BULK_TEXT_TO_PAY',
        type: 'label',
        value: 'HAMBURGER_BULK_TEXT_TO_PAY',
      },
      {
        defaultText: 'Out Of Stock',
        key: 'label.HAMBURGER_OUT_OF_STOCK',
        type: 'label',
        value: 'HAMBURGER_OUT_OF_STOCK',
      },
      {
        defaultText: 'Store Production',
        key: 'label.HAMBURGER_STORE_PRODUCTION',
        type: 'label',
        value: 'HAMBURGER_STORE_PRODUCTION',
      },
      {
        defaultText: 'Table Merge',
        key: 'label.HAMBURGER_TABLE_MERGE',
        type: 'label',
        value: 'HAMBURGER_TABLE_MERGE',
      },
      {
        defaultText: 'Assign Employee',
        key: 'label.HAMBURGER_ASSIGN_EMPLOYEE',
        type: 'label',
        value: 'HAMBURGER_ASSIGN_EMPLOYEE',
      },
      {
        defaultText: 'Sensors',
        key: 'label.HAMBURGER_SENSORS',
        type: 'label',
        value: 'HAMBURGER_SENSORS',
      },
      {
        defaultText: 'About',
        key: 'label.HAMBURGER_ABOUT',
        type: 'label',
        value: 'HAMBURGER_ABOUT',
      },
    ]
  },
  BulkTextToPayScreen: {
    screenLabel: 'Bulk Text To Pay Screen',
    image: [BulkTextToPayScreen],
    customLabels: [
      {
        defaultText: 'Check',
        key: 'label.BULK_CHECK',
        type: 'label',
        value: 'BULK_CHECK',
      },
      {
        defaultText: 'Table',
        key: 'label.BULK_TABLE',
        type: 'label',
        value: 'BULK_TABLE',
      },
      {
        defaultText: 'Employee',
        key: 'label.BULK_EMPLOYEE',
        type: 'label',
        value: 'BULK_EMPLOYEE',
      },
      {
        defaultText: 'Total',
        key: 'label.BULK_TOTAL',
        type: 'label',
        value: 'BULK_TOTAL',
      },
      {
        defaultText: 'Phone Number',
        key: 'label.BULK_PHONE_NUMBER',
        type: 'label',
        value: 'BULK_PHONE_NUMBER',
      },
      {
        defaultText: 'Status',
        key: 'label.BULK_STATUS',
        type: 'label',
        value: 'BULK_STATUS',
      },
      {
        defaultText: 'Message',
        key: 'label.BULK_MESSAGE',
        type: 'label',
        value: 'BULK_MESSAGE',
      },
      {
        defaultText: 'Submit',
        key: 'label.BULK_SUBMIT',
        type: 'label',
        value: 'BULK_SUBMIT',
      },
      {
        defaultText: 'No Checks Available',
        key: 'label.BULK_NO_CHECKS',
        type: 'label',
        value: 'BULK_NO_CHECKS',
      },
      {
        defaultText: 'OK',
        key: 'label.BULK_OK',
        type: 'label',
        value: 'BULK_OK',
      },
      {
        defaultText: 'Processing text to pay for check {{CheckNo}}',
        key: 'label.BULK_PROCESSING_TEXT_TO_PAY',
        type: 'label',
        value: 'BULK_PROCESSING_TEXT_TO_PAY',
      },
    ]
  },
  OutOfStockScreen: {
    screenLabel: 'Out of Stock Screen',
    image: [OutOfStockScreen],
    customLabels: [
      {
        defaultText: 'Out Of Stock Items',
        key: 'label.OOS_OUT_OF_STOCK_ITEMS',
        type: 'label',
        value: 'OOS_OUT_OF_STOCK_ITEMS',
      },
      {
        defaultText: 'Search',
        key: 'label.OOS_SEARCH',
        type: 'label',
        value: 'OOS_SEARCH',
      },
      {
        defaultText: 'Selected Items',
        key: 'label.OOS_SELECTED_ITEMS',
        type: 'label',
        value: 'OOS_SELECTED_ITEMS',
      },
      {
        defaultText: 'Clear All',
        key: 'label.OOS_CLEAR_ALL',
        type: 'label',
        value: 'OOS_CLEAR_ALL',
      },
      {
        defaultText: 'Mark In-Stock',
        key: 'label.OOS_MARK_IN_STOCK',
        type: 'label',
        value: 'OOS_MARK_IN_STOCK',
      },
      {
        defaultText: 'Mark Out Of Stock',
        key: 'label.OOS_MARK_OUT_OF_STOCK',
        type: 'label',
        value: 'OOS_MARK_OUT_OF_STOCK',
      },
      {
        defaultText: 'Update Stock Status',
        key: 'label.OOS_UPDATE_STOCK_STATUS',
        type: 'label',
        value: 'OOS_UPDATE_STOCK_STATUS',
      },
      {
        defaultText: 'Are you sure you want to mark this item as back in stock?',
        key: 'label.OOS_IN_STOCK_ITEM_MESSAGE',
        type: 'label',
        value: 'OOS_IN_STOCK_ITEM_MESSAGE',
      },
      {
        defaultText: 'Cancel',
        key: 'label.OOS_CANCEL',
        type: 'label',
        value: 'OOS_CANCEL',
      },
      {
        defaultText: 'Proceed',
        key: 'label.OOS_PROCEED',
        type: 'label',
        value: 'OOS_PROCEED',
      },
      {
        defaultText: 'Are you sure you want to mark this item as Out of Stock?',
        key: 'label.OOS_ITEM_MESSAGE',
        type: 'label',
        value: 'OOS_ITEM_MESSAGE',
      },
      {
        defaultText: 'Optionally, you can specify a date when the item will be back in stock.',
        key: 'label.OOS_ITEM_DATE_MESSAGE',
        type: 'label',
        value: 'OOS_ITEM_DATE_MESSAGE',
      },
      {
        defaultText: 'Select Date',
        key: 'label.OOS_SELECT_DATE',
        type: 'label',
        value: 'OOS_SELECT_DATE',
      },
      {
        defaultText: 'Out Of Stock Modifiers',
        key: 'label.OOS_OUT_OF_STOCK_MODIFIERS',
        type: 'label',
        value: 'OOS_OUT_OF_STOCK_MODIFIERS',
      },
      {
        defaultText: 'Selected Modifiers',
        key: 'label.OOS_SELECTED_MODIFIERS',
        type: 'label',
        value: 'OOS_SELECTED_MODIFIERS',
      },
      {
        defaultText: 'Are you sure you want to mark this modifier as back in stock?',
        key: 'label.OOS_IN_STOCK_MODIFIER_MESSAGE',
        type: 'label',
        value: 'OOS_IN_STOCK_MODIFIER_MESSAGE',
      },
      {
        defaultText: 'Are you sure you want to mark this modifier as Out of Stock?',
        key: 'label.OOS_MODIFIER_MESSAGE',
        type: 'label',
        value: 'OOS_MODIFIER_MESSAGE',
      },
      {
        defaultText: 'Optionally, you can specify a date when the modifier will be back in stock.',
        key: 'label.OOS_MODIFIER_DATE_MESSAGE',
        type: 'label',
        value: 'OOS_MODIFIER_DATE_MESSAGE',
      },
      {
        defaultText: 'No Modifiers',
        key: 'label.OOS_NO_MODIFIERS',
        type: 'label',
        value: 'OOS_NO_MODIFIERS',
      },
      {
        defaultText: 'No Items',
        key: 'label.OOS_NO_ITEMS',
        type: 'label',
        value: 'OOS_NO_ITEMS',
      },
      {
        defaultText: 'No Modifiers Found',
        key: 'label.OOS_NO_MODIFIERS_FOUND',
        type: 'label',
        value: 'OOS_NO_MODIFIERS_FOUND',
      },
      {
        defaultText: 'No Items Found',
        key: 'label.OOS_NO_ITEMS_FOUND',
        type: 'label',
        value: 'OOS_NO_ITEMS_FOUND',
      },
    ]
  },
  AssignEmployeeScreen: {
    screenLabel: 'Assign Employee Screen',
    image: [AssignEmployeeScreen],
    customLabels: [
      {
        defaultText: 'Employees',
        key: 'label.ASSIGN_EMPLOYEE_EMPLOYEES',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_EMPLOYEES',
      },
      {
        defaultText: 'Search',
        key: 'label.ASSIGN_EMPLOYEE_SEARCH',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_SEARCH',
      },
      {
        defaultText: 'All',
        key: 'label.ASSIGN_EMPLOYEE_ALL',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_ALL',
      },
      {
        defaultText: 'Assigned',
        key: 'label.ASSIGN_EMPLOYEE_ASSIGNED',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_ASSIGNED',
      },
      {
        defaultText: 'Unassigned',
        key: 'label.ASSIGN_EMPLOYEE_UNASSIGNED',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_UNASSIGNED',
      },
      {
        defaultText: 'Assign',
        key: 'label.ASSIGN_EMPLOYEE_ASSIGN',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_ASSIGN',
      },
      {
        defaultText: 'Assign Table',
        key: 'label.ASSIGN_EMPLOYEE_ASSIGN_TABLE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_ASSIGN_TABLE',
      },
      {
        defaultText: 'This will assign the table(s) to Employee {{posId}}. Do you want to continue? (eg: This will assign the table(s) to Employee 234. Do you want to continue?)',
        key: 'label.ASSIGN_EMPLOYEE_ASSIGN_TABLE_MESSAGE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_ASSIGN_TABLE_MESSAGE',
      },
      {
        defaultText: 'Yes',
        key: 'label.ASSIGN_EMPLOYEE_YES',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_YES',
      },
      {
        defaultText: 'No',
        key: 'label.ASSIGN_EMPLOYEE_NO',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_NO',
      },
      {
        defaultText: 'Delete Table',
        key: 'label.ASSIGN_EMPLOYEE_DELETE_TABLE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_DELETE_TABLE',
      },
      {
        defaultText: 'This will delete the Table {{TableNo}} from Employee {{posId}}. Do you want to continue? (eg: This will delete the Table 10 from Employee 234. Do you want to continue?)',
        key: 'label.ASSIGN_EMPLOYEE_DELETE_TABLE_MESSAGE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_DELETE_TABLE_MESSAGE',
      },
      {
        defaultText: 'This will delete all the tables from Employee {{posId}}. Do you want to continue? (eg: This will delete the Tables from Employee 234. Do you want to continue?)',
        key: 'label.ASSIGN_EMPLOYEE_DELETEALL_TABLE_MESSAGE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_DELETEALL_TABLE_MESSAGE',
      },
      {
        defaultText: 'Tables',
        key: 'label.ASSIGN_EMPLOYEE_TABLES',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_TABLES',
      },
      {
        defaultText: 'Assign Employee',
        key: 'label.ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE',
      },
      {
        defaultText: 'This will assign Employee {{EmployeeName}} to Table {{TableNo}}. Do you want to continue? (eg: This will assign Employee 234 to Table 10. Do you want to continue?)',
        key: 'label.ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE_MESSAGE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE_MESSAGE',
      },
      {
        defaultText: 'Delete Employee',
        key: 'label.ASSIGN_EMPLOYEE_DELETE_EMPLOYEE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_DELETE_EMPLOYEE',
      },
      {
        defaultText: 'This will remove the assignment for {{EmployeeName}} from Table {{TableNo}}. Do you want to continue? (eg: This will remove the assignment for Rob from Table 9. Do you want to continue?)',
        key: 'label.ASSIGN_EMPLOYEE_DELETE_EMPLOYEE_MESSAGE',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_DELETE_EMPLOYEE_MESSAGE',
      },
      {
        defaultText: 'No Tables Found',
        key: 'label.ASSIGN_EMPLOYEE_NO_TABLES',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_NO_TABLES',
      },
      {
        defaultText: 'No Employees Found',
        key: 'label.ASSIGN_EMPLOYEE_NO_EMPLOYEES',
        type: 'label',
        value: 'ASSIGN_EMPLOYEE_NO_EMPLOYEES',
      },
    ]
  },
  SensorsScreen: {
    screenLabel: 'Sensors Screen',
    image: [SensorsScreen],
    customLabels: [
      {
        defaultText: 'Search',
        key: 'label.TABLE_SENSOR_SEARCH',
        type: 'label',
        value: 'TABLE_SENSOR_SEARCH',
      },
      {
        defaultText: 'Table',
        key: 'label.TABLE_SENSOR_TABLE',
        type: 'label',
        value: 'TABLE_SENSOR_TABLE',
      },
      {
        defaultText: 'Sensor Group',
        key: 'label.TABLE_SENSOR_SENSOR_GROUP',
        type: 'label',
        value: 'TABLE_SENSOR_SENSOR_GROUP',
      },
      {
        defaultText: 'Please make a selection',
        key: 'label.TABLE_SENSOR_SELECTION',
        type: 'label',
        value: 'TABLE_SENSOR_SELECTION',
      },
      {
        defaultText: 'Clear',
        key: 'label.TABLE_SENSOR_CLEAR',
        type: 'label',
        value: 'TABLE_SENSOR_CLEAR',
      },
      {
        defaultText: 'Add QR',
        key: 'label.TABLE_SENSOR_ADDQR',
        type: 'label',
        value: 'TABLE_SENSOR_ADDQR',
      },
      {
        defaultText: 'Fit the barcode completely into the box below',
        key: 'label.TABLE_SENSOR_FIT_BARCODE',
        type: 'label',
        value: 'TABLE_SENSOR_FIT_BARCODE',
      },
      {
        defaultText: 'Sensor successfully added',
        key: 'label.TABLE_SENSOR_SENSOR_ADDED',
        type: 'label',
        value: 'TABLE_SENSOR_SENSOR_ADDED',
      },
      {
        defaultText: 'Re-Scan',
        key: 'label.TABLE_SENSOR_RESCAN',
        type: 'label',
        value: 'TABLE_SENSOR_RESCAN',
      },
      {
        defaultText: 'Done',
        key: 'label.TABLE_SENSOR_DONE',
        type: 'label',
        value: 'TABLE_SENSOR_DONE',
      },
      {
        defaultText: 'Sensor Code',
        key: 'label.TABLE_SENSOR_SENSOR_CODE',
        type: 'label',
        value: 'TABLE_SENSOR_SENSOR_CODE',
      },
      {
        defaultText: 'Submit',
        key: 'label.TABLE_SENSOR_SUBMIT',
        type: 'label',
        value: 'TABLE_SENSOR_SUBMIT',
      },
      {
        defaultText: 'Delete Sensor',
        key: 'label.TABLE_SENSOR_DELETE_SENSOR',
        type: 'label',
        value: 'TABLE_SENSOR_DELETE_SENSOR',
      },
      {
        defaultText: 'This will delete the sensor from Table {{stationName}}. Do you want to continue? (eg: This will delete the sensor from Table 20. Do you want to continue)',
        key: 'label.TABLE_SENSOR_DELETE_SENSOR_MESSAGE',
        type: 'label',
        value: 'TABLE_SENSOR_DELETE_SENSOR_MESSAGE',
      },
      {
        defaultText: 'Failed to register sensor. Please try again.',
        key: 'label.TABLE_SENSOR_FAILED_MESSAGE',
        type: 'label',
        value: 'TABLE_SENSOR_FAILED_MESSAGE',
      },
      {
        defaultText: 'Yes',
        key: 'label.TABLE_SENSOR_YES',
        type: 'label',
        value: 'TABLE_SENSOR_YES',
      },
      {
        defaultText: 'No',
        key: 'label.TABLE_SENSOR_NO',
        type: 'label',
        value: 'TABLE_SENSOR_NO',
      },
      {
        defaultText: 'Add Sensor',
        key: 'label.NAMED_SENSOR',
        type: 'label',
        value: 'NAMED_SENSOR',
      },
      {
        defaultText: 'Name of the Sensor',
        key: 'label.NAMED_SENSOR_NAME_OF_SENSOR',
        type: 'label',
        value: 'NAMED_SENSOR_NAME_OF_SENSOR',
      },
      {
        defaultText: 'Enter the name',
        key: 'label.NAMED_ENTER_NAME',
        type: 'label',
        value: 'NAMED_ENTER_NAME',
      },
      {
        defaultText: 'Name',
        key: 'label.NAMED_SENSOR_NAME',
        type: 'label',
        value: 'NAMED_SENSOR_NAME',
      },
      {
        defaultText: 'This will delete the named sensor. Do you want to continue?',
        key: 'label.NAMED_DELETE_SENSOR',
        type: 'label',
        value: 'NAMED_DELETE_SENSOR',
      },
      {
        defaultText: 'Sensor with this code is already registered.',
        key: 'label.SENSOR_DUPLICATE_MESSAGE',
        type: 'label',
        value: 'SENSOR_DUPLICATE_MESSAGE',
      },
      {
        defaultText: 'No Sensors Found',
        key: 'label.SENSOR_NO_DATA',
        type: 'label',
        value: 'SENSOR_NO_DATA',
      },
    ]
  },
  AboutScreen: {
    screenLabel: 'About Screen',
    image: [AboutScreen],
    customLabels: [
      {
        defaultText: 'System Information',
        key: 'label.ABOUT_SYSTEM_INFO',
        type: 'label',
        value: 'ABOUT_SYSTEM_INFO',
      },
      {
        defaultText: 'Store Name',
        key: 'label.ABOUT_STORE_NAME',
        type: 'label',
        value: 'ABOUT_STORE_NAME',
      },
      {
        defaultText: 'Device Name',
        key: 'label.ABOUT_DEVICE_NAME',
        type: 'label',
        value: 'ABOUT_DEVICE_NAME',
      },
      {
        defaultText: 'Device Group Name',
        key: 'label.ABOUT_DEVICE_GROUP_NAME',
        type: 'label',
        value: 'ABOUT_DEVICE_GROUP_NAME',
      },
      {
        defaultText: 'Web Version',
        key: 'label.ABOUT_WEB_VERSION',
        type: 'label',
        value: 'ABOUT_WEB_VERSION',
      },
      {
        defaultText: 'Environment',
        key: 'label.ABOUT_ENVIRONMENT',
        type: 'label',
        value: 'ABOUT_ENVIRONMENT',
      },
      {
        defaultText: 'Support and Contact',
        key: 'label.ABOUT_SUPPORT_CONTACT',
        type: 'label',
        value: 'ABOUT_SUPPORT_CONTACT',
      },
      {
        defaultText: 'Support & Contact - OneDine',
        key: 'label.ABOUT_ONEDINE',
        type: 'label',
        value: 'ABOUT_ONEDINE',
      },
      {
        defaultText: 'DoorDash Drive Delivery',
        key: 'label.ABOUT_DOORDASH_DRIVE_DELIVERY',
        type: 'label',
        value: 'ABOUT_DOORDASH_DRIVE_DELIVERY',
      },
      {
        defaultText: 'DoorDash Marketplace',
        key: 'label.ABOUT_DOORDASH_MARKETPLACE',
        type: 'label',
        value: 'ABOUT_DOORDASH_MARKETPLACE',
      },
      {
        defaultText: 'Grubhub Marketplace',
        key: 'label.ABOUT_GRUBHUB_MARKETPLACE',
        type: 'label',
        value: 'ABOUT_GRUBHUB_MARKETPLACE',
      },
      {
        defaultText: 'UberEats Marketplace',
        key: 'label.ABOUT_UBEREATS_MARKETPLACE',
        type: 'label',
        value: 'ABOUT_UBEREATS_MARKETPLACE',
      },
    ]
  },
  CountersScreen: {
    screenLabel: 'Counters',
    image: [CountersScreen],
    customLabels: [
      {
        defaultText: 'All Checks',
        key: 'label.COUNTER_ALL_CHECKS',
        type: 'label',
        value: 'COUNTER_ALL_CHECKS',
      },
      {
        defaultText: 'Open',
        key: 'label.COUNTER_OPEN',
        type: 'label',
        value: 'COUNTER_OPEN',
      },
      {
        defaultText: 'Paid',
        key: 'label.COUNTER_PAID',
        type: 'label',
        value: 'COUNTER_PAID',
      },
      {
        defaultText: 'Partial Paid',
        key: 'label.COUNTER_PARTIAL_PAID',
        type: 'label',
        value: 'COUNTER_PARTIAL_PAID',
      },
      {
        defaultText: 'Unpaid',
        key: 'label.COUNTER_UNPAID',
        type: 'label',
        value: 'COUNTER_UNPAID',
      },
      // {
      //   defaultText: 'Pre Auth',
      //   key: 'label.COUNTER_PRE_AUTH',
      //   type: 'label',
      //   value: 'COUNTER_PRE_AUTH',
      // },
      {
        defaultText: 'Pending',
        key: 'label.COUNTER_PENDING',
        type: 'label',
        value: 'COUNTER_PENDING',
      },
      {
        defaultText: 'In Progress',
        key: 'label.COUNTER_IN_PROGRESS',
        type: 'label',
        value: 'COUNTER_IN_PROGRESS',
      },
      {
        defaultText: 'Done',
        key: 'label.COUNTER_DONE',
        type: 'label',
        value: 'COUNTER_DONE',
      },
      {
        defaultText: 'Picked Up',
        key: 'label.COUNTER_PICKED_UP',
        type: 'label',
        value: 'COUNTER_PICKED_UP',
      },
      {
        defaultText: 'Checked In',
        key: 'label.COUNTER_CHECKED_IN',
        type: 'label',
        value: 'COUNTER_CHECKED_IN',
      },
      {
        defaultText: 'Unassigned',
        key: 'label.COUNTER_UNASSIGNED',
        type: 'label',
        value: 'COUNTER_UNASSIGNED',
      },
      {
        defaultText: 'Repost',
        key: 'label.COUNTER_REPOST',
        type: 'label',
        value: 'COUNTER_REPOST',
      },
    ]
  },
  ToastMessagesScreen: {
    screenLabel: 'Toast Messages',
    customLabels: [
      {
        defaultText: 'Order Status Updated Successfully',
        key: 'label.TOAST_ORDER_STATUS',
        type: 'label',
        value: 'TOAST_ORDER_STATUS',
      },
      {
        defaultText: 'Notification Sent Successfully',
        key: 'label.TOAST_NOTIFY_GUEST',
        type: 'label',
        value: 'TOAST_NOTIFY_GUEST',
      },
      {
        defaultText: 'Request Successful',
        key: 'label.TOAST_SUCCESS',
        type: 'label',
        value: 'TOAST_SUCCESS',
      },
      {
        defaultText: 'Email Sent Successfully',
        key: 'label.TOAST_EMAIL_SUCCESS',
        type: 'label',
        value: 'TOAST_EMAIL_SUCCESS',
      },
      {
        defaultText: 'SMS Sent Successfully',
        key: 'label.TOAST_SMS_SUCCESS',
        type: 'label',
        value: 'TOAST_SMS_SUCCESS',
      },
      {
        defaultText: 'Successfully Marked As Out Of Stock',
        key: 'label.TOAST_MARK_OUTOFSTOCK',
        type: 'label',
        value: 'TOAST_MARK_OUTOFSTOCK',
      },
      {
        defaultText: 'Successfully Marked As In Stock',
        key: 'label.TOAST_MARK_INSTOCK',
        type: 'label',
        value: 'TOAST_MARK_INSTOCK',
      },
      {
        defaultText: 'Successfully Assigned Table(s)',
        key: 'label.TOAST_ASSIGN_TABLE',
        type: 'label',
        value: 'TOAST_ASSIGN_TABLE',
      },
      {
        defaultText: 'Successfully Assigned Employee',
        key: 'label.TOAST_ASSIGN_EMPLOYEE',
        type: 'label',
        value: 'TOAST_ASSIGN_EMPLOYEE',
      },
      {
        defaultText: 'Successfully Deleted Table(s)',
        key: 'label.TOAST_DELETE_TABLE',
        type: 'label',
        value: 'TOAST_DELETE_TABLE',
      },
      {
        defaultText: 'Successfully Deleted Employee',
        key: 'label.TOAST_DELETE_EMPLOYEE',
        type: 'label',
        value: 'TOAST_DELETE_EMPLOYEE',
      },
      {
        defaultText: 'Successfully Added Sensor',
        key: 'label.TOAST_ADD_SENSOR',
        type: 'label',
        value: 'TOAST_ADD_SENSOR',
      },
      {
        defaultText: 'Successfully Updated Sensor',
        key: 'label.TOAST_UPDATE_SENSOR',
        type: 'label',
        value: 'TOAST_UPDATE_SENSOR',
      },
      {
        defaultText: 'Successfully Deleted Sensor',
        key: 'label.TOAST_DELETE_SENSOR',
        type: 'label',
        value: 'TOAST_DELETE_SENSOR',
      },
      {
        defaultText: 'Slot {{SlotNo}} Is Assigned',
        key: 'label.TOAST_ASSIGN_SLOT',
        type: 'label',
        value: 'TOAST_ASSIGN_SLOT',
      },
      {
        defaultText: 'Successfully Cleared Slot {{SlotNo}}',
        key: 'label.TOAST_CLEAR_SLOT',
        type: 'label',
        value: 'TOAST_CLEAR_SLOT',
      },
      {
        defaultText: 'Successfully Moved To Slot {{SlotNo}}',
        key: 'label.TOAST_MOVE_SLOT',
        type: 'label',
        value: 'TOAST_MOVE_SLOT',
      },
    ]
  },
  LoaderComponentsScreen: {
    screenLabel: 'Loader Components',
    image: [LoaderComponentsScreen],
    customLabels: [
      {
        defaultText: 'Processing Request',
        key: 'label.LOADER_PROCESSING_REQUEST',
        type: 'label',
        value: 'LOADER_PROCESSING_REQUEST',
      },
      {
        defaultText: 'This should only take a moment.',
        key: 'label.LOADER_SPINNER_MESSAGE',
        type: 'label',
        value: 'LOADER_SPINNER_MESSAGE',
      },
      {
        defaultText: 'Request completed successfully',
        key: 'label.LOADER_SUCCESS_MESSAGE',
        type: 'label',
        value: 'LOADER_SUCCESS_MESSAGE',
      },
    ]
  },
};
